import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Box, Divider, Stack, Tooltip, Typography } from '@mui/material';

interface renderFeedbackCountHeaderOptions {
  isNormalised: boolean;
  fieldDisplayName: string | undefined;
  headerName: string;
}

export function renderFeedbackCountHeader({
  isNormalised,
  fieldDisplayName,
  headerName,
}: renderFeedbackCountHeaderOptions) {
  if (!isNormalised) {
    return undefined;
  }

  const tooltipContent = (
    <>
      <Typography variant="caption">CALCULATION:</Typography>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Box>
          <Stack
            direction="row"
            justifyContent="space-between"
            whiteSpace="nowrap"
            spacing={1}
          >
            <Typography variant="caption">
              Feedback records of a{' '}
              <Typography variant="caption" component="span">
                {fieldDisplayName || 'Group by item'}
              </Typography>
            </Typography>
            <Typography variant="caption">(X)</Typography>
          </Stack>
          <Divider />
          <Stack
            direction="row"
            justifyContent="space-between"
            whiteSpace="nowrap"
            spacing={1}
          >
            <Typography variant="caption">
              Total no. of unique records matching your query
            </Typography>
            <Typography variant="caption">(Y)</Typography>
          </Stack>
        </Box>
        <Typography variant="subtitle1">X 100</Typography>
      </Stack>
    </>
  );

  return (
    <>
      <Tooltip
        placement="left"
        arrow
        title={tooltipContent}
        componentsProps={{
          tooltip: {
            sx: {
              p: 1,
              maxWidth: 400,
            },
          },
        }}
      >
        <InfoOutlined fontSize="small" sx={{ mr: 0.5 }} />
      </Tooltip>
      {headerName}
    </>
  );
}
